export default __webpack_public_path__ + "static/media/11.0a5048b1.png";